import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { CommonMaterialModule } from './common/common-material.module';
import { SessionGuard } from './auth/session-guard.service';
import { LoginComponent } from './auth/login.component';
import { LoginFormComponent } from './auth/login-form.component';
import { RegisterComponent } from './registration/register.component';
import { DashboardComponent } from './dashboard.component';
import { LedgerSidebarComponent } from './ledger-sidebar.component';
import { TxnsEnterComponent } from './txns/enter.component';
import { TxnsEditComponent } from './txns/edit.component';
import { SheetsComponent } from './sheets/sheets.component';
import { EditSheetComponent } from './sheets/edit.component';
import { EditAccountComponent } from './accounts/edit-account.component';
import { PrintFundsComponent } from './funds/print.component';
import { EditFundComponent } from './funds/edit-fund.component';
import { SettingsComponent } from './settings/settings.component';
import { SettingsSidebarComponent } from './settings/sidebar.component';
import { UserSettingsComponent } from './settings/user.component';
import { EmailSettingsComponent } from './settings/email.component';
import { PasswordSettingsComponent } from './settings/password.component';
import { LedgerSettingsComponent } from './settings/ledger.component';
import { SearchComponent } from './search/search.component';
import { SearchSidebarComponent } from './search/sidebar.component';

const routes: Routes = [
  { path: '', canActivateChild: [SessionGuard], children: [
    { path: '', component: DashboardComponent },
    { path: '', component: LedgerSidebarComponent, outlet: 'sidebar' },
    { path: 'enter', component: TxnsEnterComponent },
    { path: 'txns/:id/edit', component: TxnsEditComponent },
    { path: 'accounts/new', component: EditAccountComponent },
    { path: 'accounts/:id/edit', component: EditAccountComponent },
    { path: 'funds/print', component: PrintFundsComponent },
    { path: 'funds/new', component: EditFundComponent },
    { path: 'funds/:id/edit', component: EditFundComponent },
    { path: 'sheets', component: SheetsComponent },
    { path: 'sheets/new', component: EditSheetComponent },
    { path: 'sheets/:id/edit', component: EditSheetComponent },
  ] },

  { path: 'search', canActivateChild: [SessionGuard], children: [
    { path: '', component: SearchComponent },
    { path: '', component: SearchSidebarComponent, outlet: 'sidebar' },
  ] },

  { path: 'account', canActivateChild: [SessionGuard], children: [
    { path: '', component: SettingsComponent },
    { path: '', component: SettingsSidebarComponent, outlet: 'sidebar' },
    { path: 'edit', component: UserSettingsComponent },
    { path: 'email', component: EmailSettingsComponent },
    { path: 'password', component: PasswordSettingsComponent },
    { path: 'ledger', component: LedgerSettingsComponent },
  ] },

  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
];

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    RegisterComponent,
    DashboardComponent,
    LedgerSidebarComponent,
    TxnsEnterComponent,
    TxnsEditComponent,
    SheetsComponent,
    EditSheetComponent,
    EditAccountComponent,
    PrintFundsComponent,
    EditFundComponent,
    SettingsComponent,
    SettingsSidebarComponent,
    UserSettingsComponent,
    EmailSettingsComponent,
    PasswordSettingsComponent,
    LedgerSettingsComponent,
    SearchComponent,
    SearchSidebarComponent,
  ],
  imports: [
    CommonModule,
    CommonMaterialModule,
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /srv/src/app/app-routing.module.ts